module.exports = Marionette.ItemView.extend( {
	template: '#tmpl-qazana-panel-global',

	id: 'qazana-panel-global',

	initialize: function() {
		qazana.getPanelView().getCurrentPageView().search.reset();
	},

	onDestroy: function() {
		qazana.getPanelView().getCurrentPageView().showView( 'search' );
	}
} );
